import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EErrorPageTypes {
  Set = 'errorPage/set',
  Unset = 'errorPage/unset',
}

export type TErrorPageActions =
  | ITypedReduxAction<EErrorPageTypes.Set, void>
  | ITypedReduxAction<EErrorPageTypes.Unset, void>;
